import { useState } from "react";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import DateFnsUtils from '@date-io/date-fns';
import { FormControl } from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import * as dateFnsLocales from "date-fns/locale";

function DateRangeSelector ( props ) {

    const { t } = useTranslation ();

    const { onChange } = props;

    const now = new Date ();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const [ all, setAll ] = useState ( false );
    const [ from, setFrom ] = useState (firstDay);
    const [ to, setTo ] = useState (lastDay);

    const onChangeAll = ( checked ) => {

        setAll ( checked );

        if ( checked ) {

            setFrom ( null );
            setTo ( null );

            if ( onChange ) {

                onChange ( null, null );
    
            }

        } else {

            let now = new Date ();
            let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            let lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);


            setFrom ( firstDay );
            setTo ( lastDay );

            if ( onChange ) {

                onChange ( firstDay, lastDay );
    
            }
    
        }

    }

    const onFromChange = ( from ) => {

        from?.setHours ( 0, 0, 0, 0 );
        setFrom ( from );
        setTo ( ( to ) => {

            if ( from > to ) {

                if ( onChange ) {

                    onChange ( from, to );

                }

                return from;

            }

            if ( onChange ) {

                onChange ( from, to );

            }

            return to;

        })

    }

    const onToChange = ( to ) => {
        
        to?.setHours ( 0, 0, 0, 0 );
        setTo ( to );
        setFrom ( ( from ) => {

            if ( from > to ) {

                if ( onChange ) {

                    onChange ( from, to );

                }

                return to;

            }

            if ( onChange ) {

                onChange ( from, to );

            }

            return from;

        })

    }

    return (

        <div style={{marginTop: "8px"}}>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={ all }
                        color="primary"
                        name={ "all" }
                        onChange={
                            ( e ) => onChangeAll ( e.target.checked )
                        }
                    />
                }
                label={ t ( "term.all" ) }
                style={{ marginLeft: "2px", marginTop: "2px" }}
            />        

            <MuiPickersUtilsProvider locale={dateFnsLocales[t("date.localeName")]} utils={DateFnsUtils}>
                <FormControl>
                    <KeyboardDatePicker
                        variant="inline"
                        disableToolbar
                        disabled={all}
                        format={t("date.dateFormat")}
                        margin="normal"
                        style={{marginRight: "16px", marginTop: "5px", width: "140px"}}
                        value={from}
                        onChange={onFromChange}
                    />
                </FormControl>
            </MuiPickersUtilsProvider>

            <span>~</span>
            <MuiPickersUtilsProvider locale={dateFnsLocales[t("date.localeName")]} utils={DateFnsUtils}>
                <FormControl>
                    <KeyboardDatePicker
                        variant="inline"
                        disableToolbar
                        disabled={all}
                        format={t("date.dateFormat")}
                        margin="normal"
                        style={{marginLeft: "16px", marginTop: "5px", width: "140px"}}
                        value={to}
                        onChange={onToChange}
                    />
                </FormControl>
            </MuiPickersUtilsProvider>

        </div>

    );

}

export default  DateRangeSelector;

